<template>
	<div>
		<div class="m_context" style="width:100%;">
			<div class='rowFr' style="width: 100%;">
				<div style='margin-left:24px;width: 100%;' class='rowa' >
					<el-button type="primary" @click="addTerm" size="" id="addTerm" icon="plus">{{$t('app_add')}}
					</el-button>
					<el-button :disabled="!isAddTerRight" type="success" icon="" size="" id="importTerm"
						@click="importTerm()"><i class="fa fa-plus-square"
							aria-hidden="true"></i>&nbsp;{{$t('app_imp')}}</el-button>

					<el-tooltip class="item" effect="dark" :content="$t('app_rsfivemin')" placement="right">
						<el-button type="primary" @click="shuaxin" size=""><i class="fa fa-refresh"
								aria-hidden="true"></i>&nbsp;{{$t('app_refresh')}}</el-button>
					</el-tooltip>
					<el-button type="" @click="bcOutputEx" size="" icon="">{{$t('app_bcopterinfo')}}</el-button>
					<el-button type="danger" :disabled="multipleSelection.length == 0" icon="" size=""
						@click="batchDeleteRow" id="batchDeleteRow">{{$t('lin_btn.batch_delete')}}</el-button>
					<el-button :disabled="!isAddTerRight" icon="" size="" id="importTerm" @click="open_migration">
						{{$t('app_batch_migration')}}
					</el-button>
					<!-- <el-button   icon="" size="" id="importTerm" @click="time_date">
						{{$t('app_expired_button')}}
					</el-button> -->
				</div>
			</div>

			<el-row style="margin-bottom: 20px;">
				<el-col :span="11" style='margin-left:16px;'>
					<el-date-picker v-model="select_time_2" type="datetimerange"
						:placeholder="$t('app_select_timelist')" @change="statusChange">
					</el-date-picker>

				</el-col>

				<el-col :span="4">
					<div style='margin-left:16px;'>
						<MechanismSelector style='width:100%;' :data="mechanismData"></MechanismSelector>
					</div>
				</el-col>

				<el-col :span="4">
					<div style='margin-left:16px;margin-right:16px;'>
						<el-select style='width:100%' v-model="value2" @change="statusChange" placeholder="">
							<el-option v-for="item in options2" v-bind:key="item.id" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</div>
				</el-col>

				<el-col :span="4" style="padding-right:4px;">
					<div>
						<el-input :placeholder="$t('app_searchTerminal')" icon="search" v-model="dvName"
							:on-icon-click="handleIconClick" @keyup.enter.native="focusEvent(handleIconClick)">
						</el-input>
					</div>
				</el-col>
			</el-row>



			<el-table :data="arrdata" id="tp" border class='' style="width:100%;"
				@selection-change="handleSelectionChange" ref="multipleTable" @row-click="viewInfo" v-loading="loading"
				@sort-change="sortChane" :element-loading-text="$t('lin_global.loading')">
				<el-table-column type="selection" width="55">
				</el-table-column>
				<el-table-column prop="terminalName" sortable :label="$t('lin_global.label_name')">
				</el-table-column>
				<el-table-column prop="terminalNo" :label="$t('lin_global.label_no')" sortable="custom" width="150">
				</el-table-column>
				<el-table-column :label="$t('lin_global.ter_status')" prop="terminalStatus" align='center' width="150">
					<template slot-scope="scope">
						<tagc :tagobj="{type: 'terSt', vl: scope.row.terminalStatus}"></tagc>
					</template>
				</el-table-column>

				<!-- <el-table-column
	  		prop="terminalTypeName"
        :label="$t('lin_global.label_type')"
	  		width="120">
	  		</el-table-column> -->

				<el-table-column prop="mechName" :label="$t('lin_global.label_areaid')" width="220">
				</el-table-column>
				<el-table-column sortable prop="terminalOnlineTime" :label="$t('terminal.list.ztgxsj')" width="200">
				</el-table-column>
				
				
				<!-- <el-table-column prop="terminalCreateTime" :label="$t('terminal.list.ac_time')" width="200">
				</el-table-column> -->
				<!-- <el-table-column prop="expirationTime" :label="$t('terminal.list.ec_time')" width="200">
				</el-table-column> -->

				<el-table-column prop="memo" :label="$t('lin_global.remark')" width="">
				</el-table-column>

				<el-table-column align='center' :label="$t('lin_global.ope')" width="106">
					<template slot-scope="scope">
						<el-tooltip class="item" effect="dark" :content="$t('lin_btn.restart')" placement="top">
							<el-button :disabled="scope.row.disable" @click.stop="restartRow(scope.row.terminalNo,'CQ')"
								type="text"><i class="fa fa-spinner" style=""></i></el-button>
						</el-tooltip>



						<el-tooltip class="item" effect="dark" :content="$t('terminal.details.gj')" placement="top">
							<el-button :style="powerIcon(scope.row.disable)" :disabled="scope.row.disable"
								@click.stop="restartRow(scope.row.terminalNo,'GJ')" type="text"><i
									class="fa fa-power-off"></i></el-button>
						</el-tooltip>


						<el-tooltip class="item" effect="dark" :content="$t('lin_btn.delete')" placement="top">
							<el-button @click.stop="deleteRow(scope.row.terminalId)" type="text"><i class="fa fa-trash"
									style="color:#FF4949"></i></el-button>
						</el-tooltip>
					</template>
				</el-table-column>
			</el-table>
			<div class="page_content">
				<el-pagination style='float:right;' @size-change="handleSizeChange"
					@current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10,50,100]"
					:page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalRecords">
				</el-pagination>
			</div>
		</div>

		<el-dialog :before-close='exCancel' class='gDia' :title="$t('terminal.list.import_title')"
			v-model="importTermVisible" size="tiny" top="15%" :show-close="!importIsSubmit">
			<el-form style='background:none;' class='gDiaTable' :model="importForm" ref="importForm" id="importForm"
				label-width="" enctype='multipart/form-data'>
				<el-form-item label="" prop="uploadify"
					:rules="[{ required: true, message: this.$t('lin_global.qxzscwj') }]">
					<el-upload class="upload-demo" ref="upload" name="fileUpload" :action="action" :file-list="fileList"
						:on-success="handleAvatarScucess" :auto-upload="false" :show-file-list="false"
						:on-change="beforeUpload">

						<el-button slot="trigger" size="small" type="primary">{{$t('terminal.list.xqwj')}}</el-button>


						<el-button :disabled="!exFileName" style="margin-left: 10px;" size="small" type="success"
							@click="submitUpload">{{$t('terminal.list.qrdr')}}</el-button>

						<div slot="tip" class="el-upload__tip">{{$t('terminal.list.excel_tips')}}</div>

						<div style='font-size:13px;' v-show='true'>
							<label>{{$t('app_filename')}}:</label>&nbsp;&nbsp;<label>{{exFileName}}</label>
						</div>

					</el-upload>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<a :href="importTemplate" style="margin-right:10px;">
					<el-button type="success">{{$t('terminal.list.import_muban')}}</el-button>
				</a><!--  :href="importTemplate" -->
				<el-button @click="exCancel" :disabled="importIsSubmit" id="cancelBtn">{{$t('lin_btn.cancel')}}
				</el-button>
				<!--  <el-button type="primary" :loading="importIsSubmit" @click="excelUpload" id="saveBtn">保 存</el-button> -->
			</div>
		</el-dialog>

		<el-dialog :before-close='exCancel_2' class='gDia' :title="$t('app_batch_migration')"
			v-model="importTermVisible_2" size="tiny" top="15%" :show-close="!importIsSubmit">

			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
				<el-form-item :label="$t('lin_global.qudaoshangxinxi')" prop="areaid">
					<MechanismSelector :data="mechanismData_2" :mselect="true"></MechanismSelector>
				</el-form-item>
				<el-form-item :label="$t('lin_global.label_model')" prop="terminal_model">
					<el-select id="terminal_model" v-model="ruleForm.terminal_model" filterable clearable
						:placeholder="$t('terminal.add.place_model')" :disabled="is_disabled" style="width: 60%;">
						<el-option v-for="item in models" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="$t('lin_global.label_type')" prop="terminal_type">
					<el-select id="terminal_type" v-model="ruleForm.terminal_type" filterable clearable
						:placeholder="$t('terminal.add.place_type')" :disabled="is_disabled" style="width: 60%;">
						<el-option v-for="item in dvTypes" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="$t('lin_global.label_manufid')" prop="manufid">
					<el-select id="terminal_type" v-model="ruleForm.manufid" filterable clearable
						:placeholder="$t('terminal.add.place_manufid')" :disabled="is_disabled" style="width: 60%;">
						<el-option v-for="item in firms" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>


			<el-form style='background:none;' class='gDiaTable' :model="importForm" ref="importForm" id="importForm_2"
				label-width="" enctype='multipart/form-data'>
				<el-form-item label="" prop="uploadify"
					:rules="[{ required: true, message: this.$t('lin_global.qxzscwj') }]">
					<el-upload class="upload-demo" ref="upload" name="fileUpload" :action="action_2"
						:file-list="fileList" :on-success="handleAvatarScucess" :auto-upload="false"
						:show-file-list="false" :on-change="beforeUpload_2">

						<el-button slot="trigger" size="small" type="primary">{{$t('terminal.list.xqwj')}}</el-button>


						<el-button :disabled="!exFileName" style="margin-left: 10px;" size="small" type="success"
							@click="submitUpload_2">{{$t('app_sure_migration')}}</el-button>

						<div slot="tip" class="el-upload__tip">{{$t('terminal.list.excel_tips')}}</div>

						<div style='font-size:13px;' v-show='true'>
							<label>{{$t('app_filename')}}:</label>&nbsp;&nbsp;<label>{{exFileName}}</label>
						</div>

					</el-upload>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<a :href="importTerminal" style="margin-right:10px;">
					<el-button type="success">{{$t('terminal.list.import_muban')}}</el-button>
				</a><!--  :href="importTemplate" -->
				<el-button @click="exCancel_2" :disabled="importIsSubmit" id="cancelBtn">{{$t('lin_btn.cancel')}}
				</el-button>
				<!--  <el-button type="primary" :loading="importIsSubmit" @click="excelUpload" id="saveBtn">保 存</el-button> -->
			</div>
		</el-dialog>

	</div>
</template>


<script>
	import tagc from '@/components/global/tagc'
	import JQuery from 'jquery'
	import axios from 'axios'
	import {
		baseurl,
		url,
		focusEvent,
		urlAssets
	} from '../../api/url'
	import MechanismSelector from '@/components/global/mechanism_selector.vue'
	export default {
		components: {
			MechanismSelector,
			tagc
		},
		data() {
			var that = this
			return {
				terType: {
					'0': 'gray',
					'1': 'success',
					'2': 'danger',
					'3': 'warning',
					'4': 'danger'
				},
				models: [],
				dvTypes: [],
				firms: [],
				ruleForm: {
					terminal_model: "",
					terminal_type: "",
					areaid: "",
					manufid: "",
				},
				mechanismData_2: {
					callback(value) {
						that.ruleForm.areaid = value
						that.is_disabled = false
						that.getSlData(value)
					}
				},
				rules: {
					'terminal_model': [{
						required: true,
						message: this.$t('terminal.add.place_model')
					}],
					'terminal_type': [{
						required: true,
						message: this.$t('terminal.add.place_type')
					}],
					'manufid': [{
						required: true,
						message: this.$t('terminal.add.place_manufid')
					}],
					'areaid': [{
						required: true,
						message: this.$t('lin_global.place_areaid')
					}],
				},
				mechanismData: {
					callback(value) {
						that.value1 = value
						// console.log(value)
						that.getData(1, that.input1, that.value1, that.value2, that.orderValue);
					}
				},
				sorts: [{
						label: this.$t('app_utasc'),
						value: 'asc'
					},
					{
						label: this.$t('app_utdesc'),
						value: 'desc'
					}
				],
				sort: 'desc',
				exFileName: '',
				// value1: [new Date(2000, 10, 10, 10, 10), new Date(2000, 10, 11, 10, 10)],
				select_time_2: [],
				dataUpload: null,
				dvName: '',
				orderValue: '',
				terminalName: '',
				// batchSl:[],
				is_disabled: true,
				disabled: true,
				focusEvent: focusEvent,
				importTemplate: `${urlAssets.prefix}tms-server-web/model/terminals.xlsx`,
				importTerminal: `${urlAssets.prefix}tms-server-web/model/terminalNos.xlsx`,
				fileList: [],
				action: '',
				action_2: "",
				areaList1: [],
				excelUploadUrl: '',
				areaList: [],
				importForm: {
					'areaid': '',
					'uploadify': null
				},
				importForm_2: {
					'areaid': '',
					'uploadify': null
				},
				statusinfoLoading: false,
				importTermVisible: false,
				importTermVisible_2: false,
				importIsSubmit: false,
				currentPage: 1,
				expiration:"",
				pageSize: 10,
				totalRecords: 0,
				loading: true,
				reserverSelection: true,
				input1: '',
				value1: '',
				value2: '',
				multipleSelection: [],
				options2: [{
						id: 0,
						value: '',
						label: this.$t('lin_global.all_status')
					}, {
						id: 1,
						value: '0',
						label: this.$t('lin_global.new_add')
					}, {
						id: 2,
						value: '1',
						label: this.$t('lin_global.online')
					}, {
						id: 3,
						value: '2',
						label: this.$t('lin_global.offline')
					}, {
						id: 4,
						value: '3',
						label: this.$t('app_sleep')
					}
					// {
					// 	id: 5,
					//   value: '4',
					//   label: this.$t('lin_btn.lock')
					// }
				],
				areaid: '',
				arrdata: []
			}
		},
		computed: {
			isAddTerRight() {
				var menu = JSON.parse(localStorage.localMenuData)
				var ter = ''
				var ster = ''
				var sster = ''
				if (menu.length > 0) {
					menu.forEach((obj) => {
						if (obj.subId == 'd270be9f-294b-4fd5-ac83-8ad4799a640f') {
							ter = obj
						}
					})
				}
				// 1st judge
				if (ter) {
					if (ter.children.length > 0) {
						ster = ter.children
					} else {
						return false
					}
				} else {
					return false
				}

				ster.forEach(obj1 => {
					if (obj1.path == '/terList') {
						sster = obj1
					}
				})

				if (sster) {
					if (sster.children.length > 0) {
						var target = false
						sster.children.forEach(fobj => {
							if (fobj.path == '/terList/add') {
								target = true
							}
						})
						return target
					} else {
						return false
					}
				} else {
					return false
				}
			}
		},
		methods: {
			getSlData(value) {
				if (!value) {
					this.models = []
					this.dvTypes = []
					this.firms = []
					this.is_disabled = true;
					return
				}
				console.log(value)
				this.$mechGetTypes(value, res => {
					if (res.status == 200) {
						this.models = res.data.models
						this.dvTypes = res.data.types
						this.firms = res.data.manufactures
					}
				}, '')
			},
			bcOutputEx() {
				if (this.multipleSelection.length == 0) {
					var areaid = this.value1 ? this.value1 : ''
					var orderType = ''
					var time_orderType = ''
					var terminalName = this.dvName ? this.dvName : ''
					var terminal_status = this.value2 ? this.value2 : ''

					var beginTime = ""
					var endTime = ""
					if (this.select_time_2[0] !== null) {
						beginTime = this.dateFormat(this.select_time_2[0])
						endTime = this.dateFormat(this.select_time_2[1])
					}

					var terminalId = ''
					this.$outputEq2Excel(terminalId, areaid, orderType, time_orderType, terminalName, terminal_status,
						beginTime, endTime)
					return
				}

				var ids = []
				this.multipleSelection.forEach(item => {
					ids.push(item.terminalId)
				})
				this.$outputEq2Excel(ids.toString(), 'abc', '', '', '', '', '', '')
			},
			// changeSortType (vl) {
			// 	this.sort = vl
			// 	this.getData(this.currentPage,this.input1,this.value1,this.value2,this.orderValue)
			// },

			// batchTotal () {
			// 	var num = 0
			// 	this.batchSl.forEach((arr) => {
			// 		num += arr.length
			// 	})
			// 	return num
			// },
			powerIcon(vl) {
				return !vl ? "color:#FF4949" : "color: lightGray"
			},
			exCancel() {
				this.importTermVisible = false
				this.disabled = true
				if (this.exFileName) {
					// this.$router.push({path: '/'})
					// this.$router.go(-1)
					this.exFileName = ''
				}
			},
			shuaxin: function() {
				console.log("reflush")
				this.getData(1, this.input1, this.value1, this.value2, this.orderValue);
			},
			sortChane: function(val) {

				switch (val.prop) {
					case 'terminalNo':
						this.sort = ''
						if (val.order === "descending") {
							this.orderValue = "desc"
						} else if (val.order === "ascending") {
							this.orderValue = "asc"
						} else {
							this.orderValue = '';
						}
						break
					case 'terminalOnlineTime':
						this.orderValue = ''
						if (val.order === "descending") {
							this.sort = 'desc'
						} else if (val.order === "ascending") {
							this.sort = 'asc'
						} else {
							this.sort = 'desc'
						}
						break
					case 'a':
						break
				}

				this.getData(this.currentPage, this.input1, this.value1, this.value2, this.orderValue)
			},
			handleAvatarScucess(res, file) {
				//console.log("打印上传后返回");

				if (res.status == 200) {
					//this.$message.success(res.message);
					this.$notify({
						title: this.$t('terminal.list.notify_title'),
						message: res.message,
						type: 'success',
						duration: 6000
					});
					this.getData(1, '', '', '', '');
					this.importTermVisible = false;
					this.exCancel_2();

					this.exFileName = ''
					this.fileList = []
					this.$refs.upload.clearFiles()
				} else {
					this.$notify.error({
						title: this.$t('terminal.list.notify_title'),
						message: res.message,
						duration: 6000
					});
					//this.$message.error(res.message);
				}

			},
			beforeUpload(file) {
				// console.log(file)
				// console.log( typeof(file.raw))
				// this.ruleForm.fileUpload = file.raw
				if (this.importTermVisible) {
					this.disabled = false;
					this.exFileName = file.name
				} else {
					this.exFileName = ''
				}
				


			},
			beforeUpload_2(file) {
				// console.log(file)
				// console.log( typeof(file.raw))
				// this.ruleForm.fileUpload = file.raw
				if (this.importTermVisible_2) {
					this.disabled = false;
					this.exFileName = file.name
				} else {
					this.exFileName = ''
				}
				var lang = localStorage.getItem("system_lang");
				return new Promise((resolve, reject) => {
					// 拼接上传url
					// 此处动态配置action URL
					this.action_2 = `${baseurl}/terminal/moveByImport.do` + "?language=" + lang +
						'&token=' +
						localStorage.user + "&terminal_model=" + this.ruleForm.terminal_model +
						"&terminal_type=" + this.ruleForm.terminal_type + "&areaid=" + this.ruleForm
						.areaid +
						"&manufid=" + this.ruleForm.manufid
					// dom上传地址更新完成后，触发上传
					this.$nextTick(() => resolve());
				
				});

			},
			submitUpload() {
				this.$refs.upload.submit();
			},
			submitUpload_2() {
				// 上传表单数据
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						// this.action_2 = `${baseurl}/terminal/moveByImport.do` + "?language=" + lang + '&token=' +
						// 	localStorage.user + "&terminal_model=" + this.ruleForm.terminal_model +
						// 	"&terminal_type=" + this.ruleForm.terminal_type + "&areaid=" + this.ruleForm.areaid +
						// 	"&manufid=" + this.ruleForm.manufid
						// console.log(this.action_2)
						this.$refs.upload.submit(); // 提交文件
						// this.$moveByImport(this.ruleForm, (res) => {
						// 	if (res.status === 200) {
						// 		this.$message.success(res.message)
						// 		this.exCancel_2()
						// 		this.getData(1, '', '', '', '');
						// 	} else {
						// 		this.$message.error(res.message)
						// 	}
						// }, '')

					} else {
						return false
					}
				})

			},

			//			getAd1:function(){
			//		    	var params = {page:1,rows:10000};
			//		    	axios.post(`${baseurl}/mechanism/list.do`,params).then(res=>{
			//		    		console.log(res.data);
			//		    		var obj={
			//		    			'mechanismname':this.$t('lin_global.all_mechanism'),
			//		    			'mechanismid':''
			//		    		}
			//		    		this.areaList1 = res.data.data;
			//
			//		    		this.areaList1.unshift(obj)
			//		    	})
			//		    },
			getAd1: function() {
				var that = this
				var params = {
					token: localStorage.getItem('user'),
					language: localStorage.getItem("system_lang")
				};
				axios.post(`${baseurl}/mechanism/parent_list.do`, params).then(res => {
					that.areaList1 = res.data.data;


					var comp = function(grade) {
						return function(a, b) {
							return Number(a[grade]) > Number(b[grade]) ? 1 : -1;
						}
					}

					that.areaList1 = that.areaList1.sort(comp('grade'));
					var mTreeSort = function(ttmp, data, id) {
						var forE = (data, id) => {
							for (var i = 0; i < data.length; i++) {
								var item = data[i];
								if (item.pid === id) {
									ttmp.push(item)
									forE(data, item.id)
								} else {
									continue;
								}
							}
						}
						forE(data, id)
						return ttmp
					}

					var rrd = that.areaList1.filter((r) => {
						return r['grade'] === "0"
					})

					if (rrd.length > 0) {
						var ttmp = []
						ttmp.push(rrd[0])
						mTreeSort(ttmp, that.areaList1, rrd[0]['id'])

						that.areaList1 = ttmp
						var obj = {
							'name': this.$t('lin_global.all_mechanism'),
							'id': ''
						}

						this.areaList1.unshift(obj)
					}
				})
			},
			cascaderChange: function(value) {
				this.importForm.areaid = this.areaid
			},
			excelUpload: function() {
				let self = this
				let rq = {
					upload: true,
					formElement: 'importForm',
					areaid: this.areaid
				}
				return
				this.$refs['importForm'].validate((valid) => {
					if (valid) {
						this.importIsSubmit = true
						this.$httpzi.post(this.excelUploadUrl, rq, {
							// this.$http.post('123', rq, {
							timeout: 1800000,
							headers: {
								'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundarysk65tc7lJeq2YMf7'
							}
						}).then(function(response) {
							let rs = response.data
							self.importIsSubmit = false
							if (rs.status === 200) {
								self.importTermVisible = false
								if (rs.data !== '' || rs.data !== null) {
									self.$alert(rs.data, this.$t('lin_btn.tips'), {
										confirmButtonText: this.$t('lin_btn.confirm')
									})
								}
								// self.$message.success('导入设备信息成功')
								self.getData(self.currentPage, '', '', '', '')
							} else {
								//self.$ztApi.getErrorMess(rs.errorCode)
							}
						}).catch(function(error) {
							self.importIsSubmit = false
							self.$message.error(error.toString())
							//console.log(error)
						})
					} else {
						return false
					}
				})
			},
			getAd: function() {
				var params = {
					page: 1,
					rows: 10000
				};
				axios.post(`${baseurl}/mechanism/list.do`, params).then(res => {
					//console.log(res.data);
					this.areaList = res.data.data;
				})
			},
			formatStatus: function(row, column) {

				switch (row.terminal_status) {
					case '0':
						return this.$t('lin_global.new_add')
						break
					case '1':
						return this.$t('lin_global.online')
						break
					case '2':
						return this.$t('lin_global.offline')
						break
					case '3':
						return this.$t('app_sleep')
						break
				}
			},
			toggleSelection(rows) {
				if (rows) {
					rows.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row);
					});
				} else {
					this.$refs.multipleTable.clearSelection();
				}
			},
			handleSizeChange: function(val) {

				// this.batchSl = []

				this.pageSize = val
				this.getData(this.currentPage, this.input1, this.value1, this.value2, this.orderValue)
				//console.log(`每页 ${val} 条`)

			},
			handleCurrentChange: function(val) {

				// this.batchSl[this.currentPage-1] = this.multipleSelection

				this.currentPage = val
				this.getData(this.currentPage, this.input1, this.value1, this.value2, this.orderValue)
				//console.log('当前页: ${val}')

			},
			viewInfo: function(row, event, a) {
				//console.log("打印列表点击事件");
				//console.log(row, event);
				if (!a.label || a.label === this.$t('app_operate')) {
					return false
				} else {
					var obj = {
						terId: row.terminalId,
						terNo: row.terminalNo,
						ter: row
					}
					this.$store.dispatch('setTerParam', obj)
					this.$router.push({
						////path: '/terList/' + row.terminalId + '/details/' + row.terminalNo
						path: '/terList/' + row.terminalId + '/details'
					})
				}

			},
			deleteRow: function(id) {
				var params = {
					'ids': id
				}
				this.$confirm(this.$t('terminal.list.delete_tips'), this.$t('lin_btn.tips'), {
					confirmButtonText: this.$t('lin_btn.confirm'),
					cancelButtonText: this.$t('lin_btn.cancel'),
					type: 'warning'
				}).then(() => {
					axios.post(`${baseurl}/terminal/delete.do`, params).then((response) => {
						//console.log("打印看下删除返回")
						//console.log(response)
						let rs = response.data;
						if (rs.status == 200) {
							this.$message.success(this.$t('lin_global.delete_success'))
							this.getData(this.currentPage, this.input1, this.value1, this.value2, this
								.orderValue)
						} else {}
					}).catch(function(error) {
						//console.log(error)
					})
				}).catch(() => {

				})
			},
			restartRow: function(no, order) {
				//console.log("打印设备编号"+no);
				let text = {
					'CQ': this.$t('lin_btn.restart'),
					'GJ': this.$t('terminal.details.gj')

				}
				this.$confirm(this.$t('lin_global.qrjxmm') + text[order], this.$t('lin_btn.tips'), {
					confirmButtonText: this.$t('lin_btn.confirm'),
					cancelButtonText: this.$t('lin_btn.cancel'),
					type: 'warning'
				}).then(() => {
					// =========================
					// ======旧代码========
					//		          this.execNo = order
					//		          let rq = {
					//		            condition: {
					//		              'terminal_no': no,
					//		              'order_type': order,
					//		              'order_content': ''
					//		            }
					//		          }
					//		          this.$httpzi.post("/terminalManagement/monitor/orderExec", rq).then((response)=> {
					//		            let rs = response.data;
					//		            console.log(rs)
					//		            self.execNo = ''
					//		            if (rs.errorCode === '00') {
					//                  this.$message.success(this.$t('lin_global.zlxfs_tips'));
					//		            } else {
					//		            }
					//		          }).catch(function (error) {
					//		            this.execNo = ''
					//                this.$message.error(this.$t('lin_global.zl_error'));
					//		          })
					// ======旧代码========
					// =========================
					// mao edit   20170907
					var that = this
					that.req.order.shutdownOrRestartTerminal({
						terminalNo: no,
						orderType: order
					}, that.$t('lin_global.zlxfs_tips'), that.$t('lin_global.zl_error'), (res) => {
						if (res.status === 200) {
							this.getData(1, this.input1, this.value1, this.value2, this.orderValue)
						}
					})

				}).catch(() => {})
			},
			statusChange() {
				this.getData(1, this.input1, this.value1, this.value2, this.orderValue)
			},
			handleIconClick() {
				this.getData(1, this.input1, this.value1, this.value2, this.orderValue)
			},
			// time_date() {
			// 	this.expiration = 2; 
			// 	this.getData(1, this.input1, this.value1, this.value2, this.orderValue)
			// 	this.expiration = ""; 
			// },
			handleSelectionChange(val) {
				this.multipleSelection = val
			},
			addTerm() {
				this.$router.push('/terList/add')
			},
			batchDeleteRow() {
				//let self = this
				this.$confirm(this.$t('terminal.list.delete_tips'), this.$t('lin_btn.tips'), {
					confirmButtonText: this.$t('lin_btn.confirm'),
					cancelButtonText: this.$t('lin_btn.cancel'),
					type: 'warning'
				}).then(() => {
					let ids = []
					if (this.multipleSelection.length === 0) {
						this.$message.error(this.$t('terminal.list.empty_tips'))
						return false
					}
					for (let i = 0; i < this.multipleSelection.length; i++) {
						ids.push(this.multipleSelection[i].terminalId)
					}
					let rq = {
						ids: ids.join(',')
					}
					axios.post(`${baseurl}/terminal/delete.do`, rq).then((response) => {
						//console.log(response)
						let rs = response.data
						if (rs.status == 200) {
							this.$message.success(this.$t('lin_global.delete_success'))
							this.getData(this.currentPage, this.input1, this.value1, this.value2, this
								.orderValue)
						} else {}
					}).catch(function(error) {
						//console.log(error)
					})
				}).catch(() => {

				})
			},
			importTerm() {

				this.importTermVisible = true;
				this.disabled = true
				this.getAd();
				//this.excelUploadUrl = `${baseurl}/terminal/importTers.do`;
				this.resetImportForm()
			},
			open_migration() {
				this.importTermVisible_2 = true;
				this.is_disabled = true
				this.getAd();
				//this.excelUploadUrl = `${baseurl}/terminal/importTers.do`;
				this.resetImportForm()
			},
			exCancel_2() {
				this.importTermVisible_2 = false;
				this.is_disabled = true
				var that = this;
				this.ruleForm = {
					terminal_model: "",
					terminal_type: "",
					areaid: "",
					manufid: "",
				}
				this.mechanismData_2 = {
					callback(value) {
						that.ruleForm.areaid = value
						that.is_disabled = false
						that.getSlData(value)
					}
				}
				if (this.exFileName) {
					this.exFileName = ''
				}
			},


			resetImportForm: function() {
				/*JQuery('.filename').val('')
				JQuery('input[name="uploadify"]').val('')*/
				this.areaid = '';
				this.fileList = []
			},
			dateFormat(dateData) {
				var date = new Date(dateData)
				var y = date.getFullYear()
				var m = date.getMonth() + 1
				m = m < 10 ? ('0' + m) : m
				var d = date.getDate()
				d = d < 10 ? ('0' + d) : d

				var hh = date.getHours()
				hh = hh < 10 ? ('0' + hh) : hh

				var mm = date.getMinutes()
				mm = mm < 10 ? ('0' + mm) : mm

				var ss = date.getSeconds()
				ss = ss < 10 ? ('0' + ss) : ss

				const time = y + '-' + m + '-' + d + ' ' + hh + ':' + mm + ':' + ss
				return time
			},
			getData(page, no, areaid, status, order) {
				//this.statusinfoLoading=true;
				this.loading = true;
				this.currentPage = page;
				let beginTime = ""
				let endTime = ""
				if (this.select_time_2[0] !== null && this.select_time_2.length !== 0) {
					beginTime = this.dateFormat(this.select_time_2[0])
					endTime = this.dateFormat(this.select_time_2[1])
				}
				var params = {
					page: page,
					rows: this.pageSize,
					// expiration:this.expiration,
					areaid: areaid,
					terminal_no: no,
					terminal_status: status,
					terminal_runtime_status: '',
					time_orderType: this.sort,
					orderType: order,
					terminalName: this.dvName,
					beginTime: beginTime ? beginTime : "",
					endTime: endTime ? endTime : ""
				}



				axios.post(`${baseurl}/terminal/list.do`, params).then(res => {
					//console.log(res.data);
					if (res.data.status == 200) {



						this.arrdata = res.data.data;
						this.totalRecords = res.data.total;
						this.loading = false;
						for (var i = 0; i < res.data.data.length; i++) {
							if (res.data.data[i].terminalStatus == 1) {
								res.data.data[i]['disable'] = false;
							} else {
								res.data.data[i]['disable'] = true;
							}
						}


						// var _this = this
						// var tsl = this.batchSl[this.currentPage - 1]
						// if (tsl) {
						// 	var tm = []
						// 	tsl.forEach((vl) => {
						// 		res.data.data.forEach((vl1) => {
						// 			if (vl.terminalNo == vl1.terminalNo)
						// 			{
						// 				tm.push(vl1)
						// 			}
						// 		})
						// 	})
						// 	setTimeout(() => {
						// 		_this.toggleSelection(tm)
						// 	},100)
						// }




					} else {
						this.loading = false;
					}

				}).catch(function(error) {

				})

			}
		},

		mounted() {
			//      this.getAd1();

			console.log('lm', JSON.parse(localStorage.localMenuData))
		},
		created: function() {
			// 判断路由是否有参数, 如果有则证明带查询状态的路由
			// 直接就根据状态查询数据
			var c = this.$store.getters.r_param;
			if (c) {
				this.$store.dispatch('setParam', null)
				this.value2 = c + ''
				this.statusChange()
			} else {
				this.getData(1, '', '', '', '');
			}
			//      if (this.$route.params.id) {
			//        this.value2 = this.$route.params.id
			//        this.statusChange()
			//      } else {
			//        this.getData(1,'','','');
			//      }

			//			this.getAd1();
			this.getAd();
			let timer = setInterval(() => {
				this.getData(1, this.input1, this.value1, this.value2, this.orderValue);
			}, 300000) //300000
			localStorage.setItem("timer", timer);
			if (localStorage.getItem("system_lang")) {
				var lang = localStorage.getItem("system_lang");
				this.action = `${baseurl}/terminal/importTers.do` + "?language=" + lang + '&token=' + localStorage.user
			}
		}
	}
</script>
<style>
	#tp td {
		cursor: pointer;
	}
</style>
<style scoped>
	.filename {
		-webkit-appearance: none;
		-moz-appearance: none;
		appearance: none;
		background-color: #fff;
		background-image: none;
		border-radius: 4px;
		border: 1px solid #bfcbd9;
		box-sizing: border-box;
		color: #1f2d3d;
		display: block;
		font-size: inherit;
		height: 36px;
		line-height: 1;
		outline: 0;
		padding: 3px 10px;
		transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
		width: 100%;
	}

	.uploader input[type=file] {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		width: 100%;
		border: 0;
		z-index: 20;
		padding: 0;
		margin: 0;
		height: 30px;
		cursor: pointer;
		filter: alpha(opacity=0);
		-moz-opacity: 0;
		-khtml-opacity: 0;
		opacity: 0;
	}
</style>



// WEBPACK FOOTER //
// list.vue?2b022c72